import React from 'react';
import { useTranslation } from 'react-i18next';

export const AppVersion = () => {
  const appVersion = process.env.REACT_APP_VERSION;
  const { t } = useTranslation();

  if (!appVersion) return null;

  return (
    <p className="text-center text-xs font-normal leading-5 text-gray-400">
      {t('error.version', { version: appVersion })}
    </p>
  );
};
